import axios, { AxiosResponse } from "axios";
import { TGetConversationIdData } from "./types";
import { RESOURCE_ENDPOINT } from "./config";
import { setApiUrl } from "../helpers";

export const getConversationId = async (): Promise<AxiosResponse<TGetConversationIdData>> => {

  const url = setApiUrl(RESOURCE_ENDPOINT)
  return axios.get(url)
}

